import { Input, OnChanges, Component, SimpleChanges } from '@angular/core';
import { Plan, FeatureData } from '../../shared/models/plan.model';
import { DirectSessionLogicService } from '../../shared/direct-session-logic.service';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-plan-selection-button',
    template:`
        <div class="card mb-4 h-100">
            <div class="card-header borderless bg-white pb-0 text-center">
                <h3>{{plan.name}}</h3>
            </div>
            <div class="card-body">
                <div class="custom-button">
                    <div class="text-sections">
                        <div><strong>\${{plan.price}}</strong> / month</div>
                        <div>{{plan.description}} tier</div>
                    </div>
                </div>
                <div class="text-center mt-4 mb-4">
                    <button class="btn w-100 btn-primary btn-rounded" (click)="selectPlan(plan)" >Choose Plan</button>
                </div>
                <div>
                    <h4>Plan Features</h4>
                    <div *ngFor="let feature of featureList">
                        <div>{{feature.featName}}</div>
                    </div>
                </div>    
            </div>
        </div>
    `,
    styleUrls: ['./plan-selection-button.component.scss'],
    standalone: true,
    imports: [ 
        NgFor
    ],
})

export class PlanSelectionComponentButton implements OnChanges {
    @Input() featuresTotal!: any[];
    @Input() plan: any;
    featureList: FeatureData[] = [];

    constructor(
        public directSessionLogic: DirectSessionLogicService,
    ) {
        this.getFeaturesList();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['featuresTotal'] || changes['plan']) {
          this.updateFeatureList();
        }
    }

    private updateFeatureList(): void {
        if (this.featuresTotal && this.plan && this.plan.planFeatures) {
          this.featureList = this.featuresTotal.filter((feature) => this.plan.planFeatures.includes(feature.featRef));
        } else {
          console.error('featuresTotal, plan, or planFeatures is undefined');
          this.featureList = []; // or handle the error as needed
        }
      }

    selectPlan(plan: Plan) {
        this.directSessionLogic.setCustomerPlan(plan);
    }

    async getFeaturesList(){
        if(this.featuresTotal != undefined){
            this.featureList = this.featuresTotal.filter((feature) => this.plan.planFeatures.includes(feature.featRef));
        }
    }

}